module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0044-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("On the night of December 8/9, French troops began relief of the Americans in the mountains north-east of Cassino, the 2ème Division d’Infanterie Marocaine taking over from the exhausted and depleted US 34th Division of the US VI Corps. Elements of the 3ème Division d’Infanterie Algérienne began relief of the US 45th Division on the VI Corps left wing on January 3, a slow process which took six days to complete. With his two divisions in the line, Juin’s French Expeditionary Corps became operational and relieved the US VI Corps headquarters on January 3. These soldiers of the 2ème Division d’Infanterie Marocaine were pictured in the mountain village of Scapoli, where the division had it its tactical headquarters.")])])]), _vm._v(" "), _c('h3', {
    staticClass: "chtit",
    attrs: {
      "id": "ch"
    }
  }, [_vm._v("The Attack of the Corps Expéditionnaire Français (January 12-16)")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0044-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Little changed, this is the view looking up Via Antonio Carderelli today.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0044-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A sentry of the Compagnie Mixte de Transmissions 87/84 (the divisional signal unit) stands guard outside divisional headquarters. Scapoli had been captured by the 133rd Infantry of the US 34th Division on November 29.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0044-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The door may have been turned into a window but this is the same corner on Via Antonio Carderelli today.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("The Corps Expéditionnaire Français, under Général Juin, launched their attack on January 12 and soon warmed to their task, showing a special flair for this type of terrain. The 2ème Division d’Infanterie Marocaine under Général de Division André Dody made for the San Biagio road, which in turn involved tackling the Costa San Pietro ridge first. In addition Dody recognised that he would have to clear the northern slopes of Monna Casale in order to assist Général de Division Joseph de Goislard de Monsabert’s 3ème Division d’Infanterie Algérienne, who had the task of capturing this peak, as well as Monte Passero and Monte Monna di Acquafondata before securing Sant’Elia. Facing them were respectively, Gebirgsjäger-Regiment 85 and Gebirgsjäger-Regiment 100 of Generalleutnant Julius Ringel’s 5. Gebirgs-Division, a relatively new, inexperienced mountain division that had lost over 1,000 casualties in the fighting in December and one that was still not fully equipped. Ringel’s orders were not to withdraw into the Gustav Line until January 25, whereas the French wanted to reach Sant’Elia and San Biagio by January 20.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0045-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Commanding the Corps Expéditionnaire Français (CEF) was Général Alphonse Juin. In 1940 he commanded the 15ème Division d’Infanterie Motorisée which was encircled at Lille and forced to surrender at the end of May. He was interned at Königstein fortress until June 1941 when he was released at the request of the Vichy government. The following November Pétain put him in command of all French land forces in North Africa. Juin was known for his anti-German views and after the Allied invasion of North Africa in November 1942, he changed sides and was subsequently appointed to command the Free French forces fighting with the Allies in Tunisia. In November 1943 De Gaulle placed him at the head of the French Expeditionary Corps in Italy.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0045-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("On January 12, leading off Fifth Army’s multi-phased strike by three corps on the Gustav Line, the French Expeditionary Corps began the attack to cross the headwaters of the Rapido and seize the high ground immediately north and north-west of Cassino, with the 2ème Division d’Infanterie Marocaine on the right aiming for Atina and the 3ème Division d’Infanterie Algérienne on the left aiming for Sant’Elia. The initial operations involved the seizure of the hills in front of the Gustav Line proper, these being held by the German 5. Gebirgs-Division as outposts of the main line.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0045-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The two French divisions each had only a single road to supply their respective attacks. For the 2ème Division d’Infanterie Marocaine it was the tortuous mountain road from Colli to Cardito. The Germans had blown the bridge over the Chiaro river, just west of the village of Cerasuolo, but the 87ème Bataillon de Génie (the divisional engineer unit) started construction of a Bailey bridge on January 12. French Army photographer Jacques Belin pictured the completed span the following day.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0045-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The view is back east towards Cerasuolo. The current bridge is upstream of the wartime one and the comparison was taken from a little higher up to get over the tree-covered hillside.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0046-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("On January 13, the 3ème Régiment de Tirailleurs Algériens, part of the 3ème Division d’Infanterie Algérienne, seized the Monna Acquafondata (1,325 metres), an important peak dominating the road to Sant’Elia, and later that day captured the village of Acquafondata, which lay south of there. Meanwhile the divisional reconnaissance unit, the 3ème Régiment de Spahis Algériens, operating as dismounted troops, had found a gap in the German lines further south on January 12. On the 15th Belin photographed Spahi soldiers outside the town.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0046-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Assuming the ruin on the left was a bridge, Jeff Plowman took his comparison just across the stream from the Acquafondata sports ground on the road from Casal Cassinese.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thus on the night of January 11/12 the 8ème Régiment de Tirailleurs Marocains set off across the snow-covered Mainarde heights in an outflanking manoeuvre and seized the Costa San Pietro ridge, holding it against three counter-attacks. To the south of them the 4ème Groupement de Tabors Marocains launched their attack against Monna Casale, finally gaining their objective around noon the following day. Things were no easier for the Algerians, whose 3ème Régiment de Tirailleurs Algériens were held up in their attack on Monte Monna di Acquafondata. The situation was saved, however, when a battalion from the 4ème Régiment de Tirailleurs Tunisiens and a squadron of the 3ème Régiment de Spahis Algériens found a gap south of Acquafondata. The axis of the attack of the 3ème Régiment de Tirailleurs Algériens was changed and by the early hours of January 13 both Monte Monna Acquafondata and Monna Casale had fallen. For this, Ringel’s 5. Gebirgs-Division paid a heavy price, the casualty rate being as high as 80 per cent in some units. As a result of this and coupled with fears that his division might be wiped out, Ringel was granted permission to conduct a fighting withdrawal to the line Monte San Croce–Vallerotonda–Portella.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0046-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A column of M5A1 Stuart light tanks and other vehicles of the 3ème Régiment de Spahis Algériens in Acquafondata. This is most probably the armoured detachment under command of Capitaine Henri Spangenberger, organised by the 3ème Division d’Infanterie Algérienne on January 11 with mission to push on Sant’Elia. It included eight Stuarts and eight M8 Howitzer Motor Carriages, seen here being passed by a party of medics. The M8 HMC was a self-propelled 75mm howitzer mounted on the chassis of a Stuart M5.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0046-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The armour was parked on the Via Cassino, the main street in the town. The road leading off to the left is the Via Piana.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0046-5.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("More of the tanks parked up at the western exit of Acquafondata and waiting to move. The prominent mountain behind is the Monna di Acquafondata, taken by the 3ème Régiment de Tirailleurs Algériens following Spangenberger’s armoured thrust.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0047-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("That same day, January 15, Général Joseph de Goislard de Monsabert, commander of the 3ème Division d’Infanterie Algérienne (second from left), arrived at Acquafondata to view the battlefield. Down in the valley below lies the village of Vallerotonda, entered by the 3ème Régiment de Tirailleurs Algériens the previous day, and further down is the valley of the upper Rapido river. The mountain on the extreme left is Monte Cairo, with 1,669 metres one of the highest peaks in the region.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Emboldened by their successes the French continued their assault on January 14 and, using Dody’s Moroccans to guard the right flank, the 3ème Régiment de Tirailleurs Algériens took Monte Ferro and entered the village of Vallerotonda.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The following day they pushed on to Monte Faullo and the La Magghiola ridge, while the 4ème Régiment de Tirailleurs Tunisiens attempted to cross a ravine between Vallerotonda and Sant’Elia to capture Point 554. The Germans threw in Ringel’s Gebirgsjäger-Regiment 100, a battalion from the 15. Panzergrenadier-Division and all other available reserves to Sant’Elia but it was of no use and by January 16 the Algerians had taken all their objectives. Later that evening they discovered that the Germans had abandoned Sant’Elia and the mountains to the north of it. With this the Corps Expéditionnaire Français called a halt to their operations.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0047-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The picture was taken on the Via Cassino just beyond the village cemetery.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0047-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("By January 15 the French had gained almost four miles, captured Sant’Elia, and forced the Germans back over the Rapido all along their front. However, their four-day offensive had exhausted the troops and taken considerable casualties. Here, an ambulance of the 3ème Bataillon Médical of the 3ème Division d’Infanterie Algérienne drives to Sant’Elia from Acquafondata. Though taken on March 20, this photograph perfectly illustrates what for many French soldiers would have been their first view of Cassino and Monte Cassino during their January advance.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0047-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The same view today, taken from a point just above the village of Portella")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64976e72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/15_Chapter5.vue
// module id = 99
// module chunks = 0